import React from "react";
import { TextInput, StyleSheet, View, Pressable } from "react-native";
import { Eye, EyeSlash } from "@phosphor-icons/react";

function CustomTextInput({
  value,
  onChangeText,
  placeholder,
  style = {},
  secureTextEntry = false,
  onToggleSecureEntry = undefined,
  ...props
}) {
  const combinedStyles = [styles.input, style];
  const hasSecureToggle = typeof onToggleSecureEntry === "function";

  const handleToggleSecureEntry = () => {
    if (hasSecureToggle) {
      onToggleSecureEntry();
    }
  };

  return (
    <View style={styles.wrapper}>
      <TextInput
        style={combinedStyles}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor="#A1A1A1"
        secureTextEntry={secureTextEntry}
        {...props}
      />
      {hasSecureToggle && (
        <Pressable onPress={handleToggleSecureEntry} style={styles.icon} accessibilityRole="button">
          {secureTextEntry ? <Eye size={20} color="#6B7280" /> : <EyeSlash size={20} color="#6B7280" />}
        </Pressable>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  input: {
    borderWidth: 1,
    borderColor: "#D1D5DB",
    color: "#1F2937",
    fontSize: 14,
    borderRadius: 8,
    width: "100%",
    padding: 10,
  },
  wrapper: {
    position: "relative",
    flex: 1,
  },
  icon: {
    position: "absolute",
    right: 10,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default CustomTextInput;
